import { render } from "./ProductListView.vue?vue&type=template&id=66b976ba&scoped=true"
import script from "./ProductListView.vue?vue&type=script&lang=js"
export * from "./ProductListView.vue?vue&type=script&lang=js"

import "./ProductListView.vue?vue&type=style&index=0&id=66b976ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b976ba"]])

export default __exports__